import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/a11y';

// Testimonial Video Block: one thumbnail per slide; Bootstrap's data API opens each video modal.
document.querySelectorAll('.testimonial-video-block').forEach((block) => {
    const prevEl = block.querySelector('.testimonial-video-prev');
    if (!prevEl) return; // single video, no carousel

    new Swiper(block.querySelector('.testimonial-video-swiper'), {
        modules: [Navigation, A11y],
        slidesPerView: 1,
        spaceBetween: 30,
        speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 400,
        navigation: {
            addIcons: false,
            prevEl,
            nextEl: block.querySelector('.testimonial-video-next'),
        },
        a11y: {
            containerRoleDescriptionMessage: 'carousel',
            prevSlideMessage: 'Previous video',
            nextSlideMessage: 'Next video',
        },
    });
});
